import styled from 'styled-components';
import { animated } from 'react-spring';

export default animated(styled.div`
  position: relative;
  float: right;
  margin-left: 0.5rem;
  width: calc(100% - 60px - 0.5rem);
  line-height: calc(60px / 2);
`);
